import { useEffect, type ReactNode } from "react";
import { useSession } from "@clerk/react";
import { ClerkProvider } from "@clerk/react";
import { useLocation } from "react-router-dom";
import { getClerkConsumerPublishableKey } from "./clerkPublishableKey";
import { consumerClerkSignInUrl } from "./resume";
import { setConsumerClerkTokenGetter } from "../services/api";
import { useSessionStore } from "../store/useSessionStore";

function ClerkTokenBridge({ children }: { children: ReactNode }) {
  const { session } = useSession();

  useEffect(() => {
    setConsumerClerkTokenGetter(async () => {
      if (!session || session.status !== "active") return null;
      return session.getToken();
    });
    return () => setConsumerClerkTokenGetter(null);
  }, [session]);

  return <>{children}</>;
}

export function ClerkConsumerRoot({ children }: { children: ReactNode }) {
  const publishableKey = getClerkConsumerPublishableKey();
  const { search } = useLocation();
  const sessionLinkId = useSessionStore((s) => s.session.data?.linkId);
  if (!publishableKey) {
    return <>{children}</>;
  }
  const signInUrl = consumerClerkSignInUrl({
    origin: window.location.origin,
    search,
    linkIdFallback: sessionLinkId,
  });
  return (
    <ClerkProvider
      publishableKey={publishableKey}
      signInUrl={signInUrl}
      signUpUrl={signInUrl}
      signInFallbackRedirectUrl={signInUrl}
      signUpFallbackRedirectUrl={signInUrl}
    >
      <ClerkTokenBridge>{children}</ClerkTokenBridge>
    </ClerkProvider>
  );
}
